import React, { useState, useEffect, useRef } from "react";
import "../../../Styles/StoreSetting.css";
import "../../../Styles/Settings/SystemAccess.css";
import "../../../Styles/Common.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  clearPermission,
  fetchEmployeeData,
  fetchPermissionData,
} from "../../../Redux/features/StoreSettings/AddEmployee/AddEmployeeSlice";
import EditPermissionLogic from "../AddEmployee/EditPermissionLogic";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import AddNewCategory from "../../../Assests/Taxes/Left.svg";
import Loader from "../../../CommonComponents/Loader";
import {
  TextField,
  Stack,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Box, display, fontSize } from "@mui/system";
import Cancel from "@mui/icons-material/Cancel";
import axios from "axios";
import {
  Collapse,
  Button,
  FormControlLabel,
  Switch,
  Grid,
  CircularProgress,
} from "@mui/material";
import Config from "../../../Constants/Config";
import { PERMISSIONS } from "../../../Constants/permission";

const Permission = ({ EmployeeId, setVisible }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [employeedata, setemployeedata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [tags, setTags] = useState([]);
  const [removedTags, setRemovedTags] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const employee_id = EmployeeId;
  const employeeListDataState = useSelector((state) => state.employeelistData);

  const [permissionArray, setPermissionArray] = useState([]);
  const hideOptionFor = ["merchant", "admin", "superadmin"];
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    if (isDropdownVisible) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isDropdownVisible, setIsDropdownVisible]);

  const {
    handleEditEmpPermissionInput,
    handleToggleCategory,
    values,
    handleEditEmpPermission,
    submitmessage,
    showModal,
    setShowModal,
    scrollRef,
    setsubmitmessage,
    open,
    setOpen,
    setValues,
    setpermissionList,
    permissionList,
  } = EditPermissionLogic({ employeedata, setVisible });
  useEffect(() => {
    const hasErrors = Object.values(values.errors).some((error) => error != "");
    // Determine whether to open based on specific values
    const shouldOpen = Boolean(
      (values.break_allowed && values.break_allowed != "0") ||
        (values.break_time && values.break_time != "0") ||
        (values.paid_breaks && values.paid_breaks != "0")
    );
    !hasErrors && setOpen(shouldOpen);
  }, [values.break_allowed, values.break_time, values.paid_breaks]);
  const toggleVisibility = () => {
    setOpen((prev) => !prev);
    setValues((prev) => ({
      ...prev,
      errors: {
        ...prev.errors,
        break_allowed: "",
        break_time: "",
        paid_breaks: "",
      },
    }));
  };
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  let stores = employeeListDataState?.employeelistData;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  const store_merchant = stores?.find((entry) => entry?.id == employee_id);
  // let   merchantID = store_merchant ? store_merchant?.merchant_id:merchant_id;
  let merchantID = store_merchant ? store_merchant?.merchant_id : 0;
  const login_user_email = AuthDecryptDataDashBoardJSONFormat?.data?.email;
  const login_user_type = AuthDecryptDataDashBoardJSONFormat?.data?.user_type;

  useEffect(() => {
    let data = {
      merchant_id: merchantID,
      employee_id: employee_id,
      ...userTypeData,
    };
    if (data && employee_id != "undefined") {
      const fetchData = async () => {
        try {
          await dispatch(fetchEmployeeData(data));
          await dispatch(fetchPermissionData(data));
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchData();
    }
    return () => {
      dispatch(clearPermission());
    };
  }, []);

  useEffect(() => {
    if (
      !employeeListDataState.loading &&
      employeeListDataState.employeeData &&
      employeeListDataState.permissionData
    ) {
      setemployeedata(employeeListDataState.employeeData);
      setpermissionList(employeeListDataState.permissionData);
      const storeNames =
        employeeListDataState?.employeeData?.assigned_stores_details;
      const storeIds = storeNames?.map((store) => store.merchant_id) || [];
      setTags(storeNames);
      setValues((prev) => ({
        ...prev,
        assigned_stores: storeIds,
      }));
    }
  }, [
    employeeListDataState,
    employeeListDataState.loading,
    employeeListDataState.employeeData,
    employeeListDataState.permissionData,
  ]);

  const permissionList_arr = [];
  function MyComponent(permissionList) {
    let index = 0;

    for (const key in permissionList) {
      if (permissionList.hasOwnProperty(key)) {
        // Create an object with a single key-value pair and push it to the array
        const obj = {};
        obj[key] = permissionList[key];
        permissionList_arr[index] = obj;
        index++;
      }
    }
    setPermissionArray(permissionList_arr);

    return (
      <div className="box">
        <div>
          <h1>{JSON.stringify(permissionList_arr)} </h1>{" "}
          {JSON.stringify(permissionList_arr)} {/* Just for demonstration */}
        </div>
        \
      </div>
    );
  }

  useEffect(() => {
    MyComponent(permissionList);
  }, [permissionList, employeedata]);

  const RedirectCancelButton = () => {
    setVisible("EmployeeList");
    setValues({
      role: "",
      break_allowed: "",
      break_time: "",
      paid_breaks: "",
      permissions: "",
      assigned_stores: "",
      unassigned_stores: "",
      errors: {
        role: "",
        break_allowed: "",
        break_time: "",
        paid_breaks: "",
        permissions: "",
      },
    });
    navigate(`/store-settings/addemployee`);
  };

  const permissionOrder = [
    "Home Screen", //
    "Register", //
    "Orders", //
    "Gift Card", //
    "Customers", //
    "Station Settings", //
    "More", //
    "Reporting", //
    "Inventory", //
    "Purchase Orders", //
    "Stocktake", //
    "Vendor", //
    "Employee", //
    "Coupons", //
    "Mix N' Match",
    "Loyalty Program",
    "Taxes", //
    "Store Settings", //
  ];
  const headings = {
    "Home Screen": "POS",
    Reporting: "Dashboard",
  };
  // Helper function to render heading based on key
  const renderHeading = (key) => {
    const title = headings[key];
    return title ? (
      <div className="text-[24px] px-2 sm:px5 mb-3">
        <h1>{title}</h1>
      </div>
    ) : null;
  };

  const handleRemoveTag = (indexToRemove) => {
    const tagToRemove = tags[indexToRemove];
    const updatedTags = tags.filter((_, index) => index != indexToRemove);
    setTags(updatedTags);
    const removedTagIds = [tagToRemove.merchant_id];
    setRemovedTags((prevRemovedTags) => [...prevRemovedTags, ...removedTagIds]);
    const updatedAssignedStores = updatedTags.map((tag) => tag.merchant_id);
    const updatedUnAssignedStores = [tagToRemove.merchant_id];
    setValues((prev) => ({
      ...prev,
      assigned_stores: updatedAssignedStores,
      unassigned_stores: updatedUnAssignedStores,
    }));
  };

  const tagRef = useRef();

  const handleOnInputChange = async (e) => {
    const inputValue = tagRef.current.value.trim();

    const payload = {
      name: inputValue,
      merchant_id: merchant_id,
      email: login_user_email,
    };
    // if (inputValue?.length > 0 && !tags?.includes(inputValue)) { // Check if tag is not empty or already present
    try {
      // setLoading(true);
      const StoreApiResponse = await axios.post(
        `${Config.BASE_URL}${Config.GET_ALL_MANAGER_STORES}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${LoginGetDashBoardRecordJson?.token}`,
          },
        }
      );

      // return;
      // return
      if (
        StoreApiResponse?.data?.status &&
        StoreApiResponse.data?.data?.length > 0
      ) {
        const data = StoreApiResponse.data?.data;
        setDropdownOptions(data);
        setIsDropdownVisible(true);
        // const totalResponseData = totalApiResponse?.data?.totals
        // setTags((prevTags) => [...prevTags, StoreApiResponse?.data]);
      } else {
        setDropdownOptions("");
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    }

    // setTags([...tags, tag]); // Add tag to the list

    // tagRef.current.value = ""; // Clear input field
    // }
  };

  const handleTagSelect = (selectedTag) => {
    const merchantId = selectedTag.merchant_id;
    if (!tags.some((tag) => tag.merchant_id == merchantId)) {
      setTags((prevTags) => [...prevTags, selectedTag]);
    }
    if (!values?.assigned_stores?.includes(merchantId)) {
      setValues((prev) => ({
        ...prev,
        assigned_stores: [...prev.assigned_stores, merchantId],
        unassigned_stores: removedTags,
      }));
    }
    tagRef.current.value = "";
    setIsDropdownVisible(false);
  };
  return (
    // fro laoder Start
    <div style={{ paddingBottom: "120px" }} className="box">
      {/* edit modal */}
      {isLoading ? (
        <div className="loading-box">
          <Loader />
        </div>
      ) : (
        <>
          <div className="q-attributes-main-page">
            <div
              className="box_shadow_div_headings"
              style={{ paddingBottom: "0px !important" }}
            >
              <div className="page_heading_area ">
                <span
                  onClick={() => {
                    setVisible("EmployeeList");
                  }}
                  className="cursor-pointer"
                  // to="/store-settings/addemployee"
                >
                  <div className="employeePromiss">
                    <img src={AddNewCategory} alt="Add-New-Category" />
                    <h1>
                      {employeedata.f_name} {employeedata.l_name}'s Permissions
                    </h1>
                  </div>
                </span>
              </div>
              <div className="box_shadow_innerdiv">
                <h2 className="heading_black">Preset Permissions</h2>
                <Grid container sx={{ mt: 0 }} spacing={2} className="">
                  <Grid item className="input_rediobutton_area">
                    <input
                      className="inputredio"
                      type="radio"
                      id="manager"
                      name="role"
                      value="manager"
                      onChange={handleEditEmpPermissionInput}
                      checked={values.role == "manager" || values.role == null}
                      // defaultChecked={values.role == 'manager' || values.role == 'null'}
                      // defaultChecked={values.role == 'manager'}
                    />
                    <label htmlFor="manager">Manager</label>
                  </Grid>
                  <Grid item className="input_rediobutton_area">
                    <input
                      className="inputredio"
                      type="radio"
                      id="cashier"
                      name="role"
                      value="cashier"
                      onChange={handleEditEmpPermissionInput}
                      checked={values.role == "cashier" && values.role != null}
                      // defaultChecked={values.role !='' && values.role == 'cashier'}
                    />
                    <label htmlFor="cashier">Cashier</label>
                  </Grid>
                  <Grid item className="input_rediobutton_area">
                    <input
                      className="inputredio"
                      type="radio"
                      id="driver"
                      name="role"
                      value="driver"
                      onChange={handleEditEmpPermissionInput}
                      checked={values.role == "driver" && values.role != null}
                      // defaultChecked={values.role !='' && values.role == 'driver'}
                    />
                    <label htmlFor="driver">Driver</label>
                  </Grid>
                  <Grid item className="input_rediobutton_area">
                    <input
                      className="inputredio"
                      type="radio"
                      id="time_clock_only"
                      name="role"
                      value="time_clock_only"
                      onChange={handleEditEmpPermissionInput}
                      checked={
                        values.role == "time_clock_only" && values.role != null
                      }
                      // defaultChecked={values.role !='' && values.role == 'time_clock_only'}
                    />
                    <label htmlFor="time_clock_only">Time Clock Only</label>
                  </Grid>
                </Grid>
                <span className="input-error">
                  {values.errors.role != "" ? values.errors.role : ""}
                </span>
              </div>
            </div>
            <div
              className="box_shadow_div_heading"
              style={{ paddingBottom: 0 }}
            >
              <div className="box_shadow_innerdiv">
                <Box className="tagifyInput" sx={{ width: "100%" }}>
                  <labe
                    style={{
                      color: "#818181",
                      marginBottom: "8px",
                      display: "inline-block",
                      fontSize: 14,
                    }}
                  >
                    Assign Store
                  </labe>
                  <TextField
                    className="inputField"
                    inputRef={tagRef}
                    fullWidth
                    variant="standard"
                    size="small"
                    sx={{ margin: "1rem 0" }}
                    margin="none"
                    disabled={
                      permissions.length &&
                      !permissions.includes(
                        PERMISSIONS.MENU_MANAGE_STORE_ACCESS
                      )
                    }
                    placeholder={"Search Store"}
                    onChange={handleOnInputChange} // Trigger on input change
                    onClick={handleOnInputChange}
                    InputProps={{
                      startAdornment: (
                        <Box
                          sx={{
                            margin: "0.2rem",
                            display: "flex",
                            flexWrap: "wrap",
                            maxWidth: "100%",
                          }}
                        >
                          {tags?.map((data, index) => (
                            <Box
                              key={index}
                              sx={{
                                background: "#F2F2F2",
                                height: "100%",
                                display: "flex",
                                padding: "0.4rem",
                                margin: "0 0.5rem 0.2rem 0",
                                justifyContent: "center",
                                alignContent: "center",
                                color: "#000",
                                borderRadius: "3px",
                                height: "32px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap={1}
                              >
                                <Typography sx={{ fontSize: 14 }}>
                                  {data?.name}
                                </Typography>
                                {hideOptionFor.includes(
                                  userTypeData?.login_type
                                ) && +employeedata?.is_admin != 1 ? (
                                  <Cancel
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => handleRemoveTag(index)}
                                  />
                                ) : null}
                              </Stack>
                            </Box>
                          ))}
                        </Box>
                      ),
                    }}
                  />

                  {isDropdownVisible &&
                    dropdownOptions.length > 0 &&
                    (!permissions.length ||
                    permissions.indexOf(PERMISSIONS.MENU_MANAGE_STORE_ACCESS) >
                      -1 ? (
                      <div className="tagifyDropdown" ref={dropdownRef}>
                        {dropdownOptions.map((store, index) => (
                          <div
                            className="tagifyDropdownItem"
                            key={index}
                            value={store.merchant_id}
                            onClick={() => handleTagSelect(store)}
                          >
                            {store.name}
                          </div>
                        ))}
                      </div>
                    ) : (
                      []
                    ))}
                </Box>
              </div>
            </div>

            <div className="">
              {/* <div className="page_heading_area">
                <h1>Permissions</h1>
              </div> */}

              {permissionArray
                .sort((a, b) => {
                  const keyA = Object.keys(a)[0];
                  const keyB = Object.keys(b)[0];
                  return (
                    permissionOrder.indexOf(keyA) -
                    permissionOrder.indexOf(keyB)
                  );
                })
                .map((item, index) => {
                  const key = Object.keys(item)[0]; // Gets the first key in the object
                  const categoryPermissions = item[key];
                  const idArray = values?.permissions?.split(",");

                  return (
                    <>
                      {renderHeading(key)}
                      <Grid
                        sx={{ marginTop: 0 }}
                        key={key}
                        className="box_shadow_div_heading"
                      >
                        <div className="px-2 sm:px-5 pt-4">
                          <div className="flex items-center justify-between">
                            <div>
                              <h2 className="heading_black">{key}</h2>
                            </div>
                            <div className="">
                              <div
                                style={{ marginRight: "0px", marginTop: "0px" }}
                                className="qv_checkbox"
                              >
                                <label className="qv_checkbox_add_checkmark_label text-center">
                                  Check All
                                  <input
                                    type="checkbox"
                                    onChange={(e) =>
                                      handleToggleCategory(
                                        categoryPermissions,
                                        e.target.checked
                                      )
                                    }
                                    checked={categoryPermissions.every(
                                      (subItem) =>
                                        idArray?.includes(
                                          String(subItem.permission_code)
                                        )
                                    )}
                                  />
                                  <span className="qv_add_checkmark"></span>
                                </label>
                              </div>
                            </div>
                          </div>

                          <Grid container sx={{ mt: 1 }}>
                            {item[key]
                              .slice()
                              .sort((a, b) =>
                                a?.alternateName?.localeCompare(
                                  b?.alternateName
                                )
                              )
                              .map((subItem, subIndex) => (
                                <Grid
                                  item
                                  xs={6}
                                  sm={4}
                                  md={3}
                                  key={subIndex}
                                  className={` ${subItem.sub_permission}`}
                                >
                                  <div className="checkbox_space">
                                    <div className="qv_checkbox">
                                      <label className="qv_checkbox_add_checkmark_label">
                                        {subItem.sub_permission}
                                        <input
                                          type="checkbox"
                                          name="permission[]"
                                          onChange={
                                            handleEditEmpPermissionInput
                                          }
                                          value={subItem.permission_code}
                                          // defaultChecked={idArray?.includes(
                                          //   String(subItem.id)
                                          // )}
                                          checked={idArray?.includes(
                                            String(subItem.permission_code)
                                          )}
                                        />
                                        <span className="qv_add_checkmark"></span>
                                      </label>
                                    </div>
                                  </div>
                                </Grid>
                              ))}
                          </Grid>
                        </div>
                      </Grid>
                    </>
                  );
                })}
            </div>

            <div className="box_shadow_div_heading">
              <Grid
                sx={{ px: { xs: 1, sm: 2.5 } }}
                className="box_shadow_innerdiv"
              >
                <div className="flex items-center justify-between">
                  <h2 className="heading_black">Time Clock Settings</h2>
                  <FormControlLabel
                    sx={{ marginRight: "0px" }}
                    control={
                      <Switch
                        checked={open}
                        onChange={toggleVisibility}
                        color="primary"
                      />
                    }
                  />
                </div>

                <Collapse in={open}>
                  <div className="mt10">
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <div className="input_area">
                          <label>Number of Breaks Allowed</label>
                          <input
                            type="text"
                            name="break_allowed"
                            onChange={(e) => {
                              if (e.target.value.length < 5) {
                                handleEditEmpPermissionInput(e);
                              }
                            }}
                            value={values.break_allowed}
                            placeholder="0"
                          />
                          <span className="input-error">
                            {values.errors.break_allowed != ""
                              ? values.errors.break_allowed
                              : ""}
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <div className="input_area">
                          <label>Minutes Per Break</label>
                          <input
                            type="text"
                            name="break_time"
                            onChange={(e) => {
                              if (e.target.value.length < 4) {
                                handleEditEmpPermissionInput(e);
                              }
                            }}
                            value={values.break_time}
                            placeholder="0"
                          />
                          <span className="input-error">
                            {values.errors.break_time != ""
                              ? values.errors.break_time
                              : ""}
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <div className="input_area">
                          <label>Number of Paid Breaks</label>
                          <input
                            type="text"
                            name="paid_breaks"
                            // onChange={handleEditEmpPermissionInput}
                            onChange={(e) => {
                              if (e.target.value.length < 5) {
                                handleEditEmpPermissionInput(e);
                              }
                            }}
                            value={values.paid_breaks}
                            placeholder="0"
                          />
                          <span className="input-error">
                            {values.errors.paid_breaks != ""
                              ? values.errors.paid_breaks
                              : ""}
                          </span>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Collapse>
              </Grid>
            </div>
          </div>
        </>
      )}
      <Grid className="fixed-bottom">
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          sx={{
            mb: 0,
            py: 2.5,
            px: { xs: 1, sm: 2.5 },
            width: "100%",
            height: "auto",
            boxShadow: "0 5px 10px 1px #ddd",
            // margin: "30px 0px",
            borderRadius: "8px",
            backgroundColor: "#fff",
            // padding: "0px",
            overflow: "hidden",
          }}
        >
          <div className=" md:mr-0">
            <div className="col-qv-12">
              <div
                style={{ padding: 0 }}
                className="q-add-categories-section-middle-footer"
              >
                <button
                  className="quic-btn quic-btn-save"
                  onClick={handleEditEmpPermission}
                >
                  Update
                </button>

                <Link
                  onClick={() => RedirectCancelButton()}
                  // to={`/store-settings/addemployee`}
                >
                  <button className="quic-btn quic-btn-cancle">Cancel</button>
                </Link>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>

    // fro laoder End
  );
};

export default Permission;
